export default "__VITE_ASSET__eRnCCO7p__"